import i18n from '../../../locales/index'
import home from './home.vue'
export default home
